module.exports = __webpack_public_path__ + "static/media/downline-account.8ff78ad8.svg";